import { Box, Typography, Container, Paper, Fade, Stack, Avatar, Divider, alpha } from '@mui/material';
import { AdminPanelSettings as AdminPanelSettingsIcon } from '@mui/icons-material';
import Authorizations from './authorization/Authorizations';


const AuthorizationPage: React.FC = () => {
  return (
    <Container maxWidth={false} sx={{
      flexGrow: 1,
      height: '100vh',
      maxHeight: '100vh',
      padding: { xs: '90px 8px 16px 8px', sm: '110px 12px 24px 12px', md: '110px 32px 40px 32px', lg: '110px 40px 40px 40px' },
      background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    }}>
      {/* Main Dashboard Container */}
      <Paper
        elevation={0}
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
          borderRadius: 4,
          background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.8) 100%)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(255,255,255,0.3)',
          boxShadow: '0 20px 40px rgba(0,0,0,0.08)',
          overflow: 'hidden',
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '6px',
            background: 'linear-gradient(90deg, #1e3c72 0%, #2a5298 25%, #3b82f6 50%, #2a5298 75%, #1e3c72 100%)',
          }
        }}
      >
        <Box sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
          py: { xs: 2, sm: 3, md: 4 },
          pb: 2,
          px: 0,
          background: 'linear-gradient(135deg, rgba(30, 60, 114, 0.03) 0%, rgba(42, 82, 152, 0.06) 100%)',
          borderBottom: '1px solid rgba(226, 232, 240, 0.8)'
        }}>
          <Fade in={true} timeout={600}>
            <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
            {/* Cover Box - Roller sayfası ile aynı stil */}
            <Box
              sx={{
                flex: 1,
                minHeight: 0,
                px: { xs: 1, sm: 1.5 },
                width: '100%',
                maxWidth: 1200,
                mx: 'auto',
                display: 'flex',
                flexDirection: 'column',
                mt: { xs: 2, sm: 3 },
                borderRadius: 3,
                border: '1px solid rgba(226, 232, 240, 0.8)',
                background: 'rgba(255,255,255,0.6)',
                overflow: 'hidden'
              }}
            >
                {/* Header Section */}
                <Box sx={{ flexShrink: 0, p: { xs: 2, sm: 2.5 }, pb: 0 }}>
                  <Stack direction="row" alignItems="center" spacing={{ xs: 1.5, sm: 2 }} sx={{ mb: 2 }}>
                    <Avatar
                      sx={{
                        width: { xs: 36, sm: 44 },
                        height: { xs: 36, sm: 44 },
                        bgcolor: 'primary.main',
                        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)'
                      }}
                    >
                      <AdminPanelSettingsIcon sx={{ fontSize: { xs: 20, sm: 24 }, color: 'white' }} />
                    </Avatar>
                    <Box>
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { xs: '1.25rem', sm: '1.4rem', md: '1.75rem' },
                          fontWeight: 800,
                          background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                          backgroundClip: 'text',
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent',
                          mb: 0.5
                        }}
                      >
                        Yetkilendirme Yönetimi
                      </Typography>
                    </Box>
                  </Stack>
                  <Divider sx={{ borderColor: (theme) => alpha(theme.palette.primary.main, 0.1) }} />
                </Box>

              {/* Main Content */}
              <Box
                sx={{
                  flex: 1,
                  minHeight: 0,
                  overflow: 'auto',
                  p: { xs: 1.5, sm: 2 }
                }}
              >
                <Authorizations />
              </Box>
            </Box>
            </Box>
          </Fade>
        </Box>
      </Paper>
    </Container>
  );
};

export default AuthorizationPage;
